import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, } from '@angular/common/http';
import { GlobalsService } from '../globals/globals.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  token: any;

  // header = {'Content-Type' : 'application/json'}
  headers = { 'Content-type': 'multipart/form-data; charset=utf-8;' };
  headers2 = { 'Content-type': 'application/x-www-form-urlencoded' };
  headers3: { "Content-Type": undefined };

  constructor(
    private http: HttpClient
  ) {

  }

  async login(data) {
    return this.http.post(`${GlobalsService.baseUrl2}/sign-in`, data).toPromise();
  }

  async getSpecificScholarData2(token, id) {
    return this.http.get(`${GlobalsService.baseUrl}/scholars/${id}?token=${token}`, { headers: this.headers2 }).toPromise();
  }

  async getSpecificScholarData(token, data) {
    return this.http.post(`${GlobalsService.baseUrlOld}?token=${token}`, data, { headers: this.headers2 }).toPromise();
  }

  async postAttachment(data, folder) {
    return this.http.post(`${GlobalsService.mediaUrl}/${folder}`, data, { headers: this.headers }).toPromise();
  }


  async getDocumentType(token) {
    return this.http.get(`${GlobalsService.baseUrl}/document_types?token=${token}`, { headers: this.headers2 }).toPromise();
  }

  // Academic Profile

  async getAcademicProfile(token, data) {
    return this.http.post(`${GlobalsService.baseUrl}/academic_profile?token=${token}`, data, { headers: this.headers2 }).toPromise();
  }

  async getAcademicProfileSpecificScholar(token, id) {
    return this.http.get(`${GlobalsService.baseUrl}/scholars/${id}/academic_profile?token=${token}`, { headers: this.headers2 }).toPromise();
  }

  async getSpecificAcademicProfile(token, academic_id) {
    return this.http.get(`${GlobalsService.baseUrl}/academic_profile/${academic_id}?token=${token}`, { headers: this.headers2 }).toPromise();
  }

  async getAcademicProfiles(token) {
    return this.http.get(`${GlobalsService.baseUrl}/academic_profile?token=${token}`, { headers: this.headers2 }).toPromise();
  }

  async getSubjects(token, academic_id, table) {
    return this.http.get(`${GlobalsService.baseUrl}/academic_profile/${academic_id}/${table}?token=${token}`, { headers: this.headers2 }).toPromise();
  }

  async getSchoolDocuments(token, academic_id, table) {
    return this.http.get(`${GlobalsService.baseUrl}/academic_profile/${academic_id}/${table}?token=${token}`, { headers: this.headers2 }).toPromise();
  }

  async addSubject(token, data) {
    return this.http.post(`${GlobalsService.baseUrl}/academic_subjects?token=${token}`, data, { headers: this.headers2 }).toPromise();
  }

  async editSubject(token, id, data) {
    return this.http.put(`${GlobalsService.baseUrl}/academic_subjects/${id}?token=${token}`, data, { headers: this.headers2 }).toPromise();
  }

  async getSchoolGradingSystem(token) {
    return this.http.get(`${GlobalsService.baseUrl}/grading_system?token=${token}`, { headers: this.headers2 }).toPromise();
  }

  async getHouseType(token) {
    return this.http.get(`${GlobalsService.baseUrl}/house_type?token=${token}`, { headers: this.headers2 }).toPromise();
  }

  // Liquidation
  async postLiquidation(token, data) {
    return this.http.post(`${GlobalsService.baseUrl2}/liquidation?token=${token}`, data, { headers: this.headers2 }).toPromise();
  }

  async putLiquidation(token, id, data) {
    return this.http.put(`${GlobalsService.baseUrl2}/liquidation/${id}?token=${token}`, data, { headers: this.headers2 }).toPromise();
  }

  async putDepositDetails(token, id, data) {
    return this.http.put(`${GlobalsService.baseUrl}/deposit_details/${id}?token=${token}`, data, { headers: this.headers2 }).toPromise();
  }

  async postDepositDetails(token, data) {
    return this.http.post(`${GlobalsService.baseUrl}/deposit_details?token=${token}`, data, { headers: this.headers2 }).toPromise();
  }

  async postFundRequest(token, data) {
    return this.http.post(`${GlobalsService.baseUrl}/request_for_funds?token=${token}`, data, { headers: this.headers2 }).toPromise();
  }

  async getLiquidation(token) {
    return this.http.get(`${GlobalsService.baseUrl}/liquidation?token=${token}`, { headers: this.headers2 }).toPromise();
  }

  async getDepositDetails(token) {
    return this.http.get(`${GlobalsService.baseUrl}/deposit_details?token=${token}`, { headers: this.headers2 }).toPromise();
  }

  async getDisbursementMethods(token) {
    return this.http.get(`${GlobalsService.baseUrl}/disbursement_methods?token=${token}`, { headers: this.headers2 }).toPromise();
  }

  async getReceiptType(token) {
    return this.http.get(`${GlobalsService.baseUrl}/receipt_types?token=${token}`, { headers: this.headers2 }).toPromise();
  }

  async getFundRequestItem(token) {
    return this.http.get(`${GlobalsService.baseUrl}/academic_group/${JSON.parse(localStorage.getItem('user')).academic_group_code}/fund_request_items?token=${token}`, { headers: this.headers2 }).toPromise();
  }

  //Commitments and Attendance  
  async postAttendance(token, data) {
    return this.http.post(`${GlobalsService.baseUrl}/commitments?token=${token}`, data, { headers: this.headers2 }).toPromise();
  }
  async getAttendance(token) {
    return this.http.get(`${GlobalsService.baseUrl}/commitments?token=${token}`, { headers: this.headers2 }).toPromise();
  }
  async getCoachingEvent(token) {
    return this.http.get(`${GlobalsService.baseUrl}/lookup/coaching_event?data&token=${token}`, { headers: this.headers2 }).toPromise();
  }

  async getRangeMonth(token, data) {
    return this.http.post(`${GlobalsService.baseUrlOld}/?token=${token}`, data, { headers: this.headers2 }).toPromise();
  }

  async getCoaches(token) {
    return this.http.get(`${GlobalsService.baseUrl}/coaches?token=${token}`, { headers: this.headers2 }).toPromise();
  }

  async getSchoolYears(token) {
    return this.http.get(`${GlobalsService.baseUrl}/school_year?token=${token}`, { headers: this.headers2 }).toPromise();
  }

  async getLifeJourney(token, data) {
    return this.http.post(`${GlobalsService.baseUrlOld}/?token=${token}`, data, { headers: this.headers2 }).toPromise();
  }

  //Scholarship
  async getOffense(token) {
    return this.http.get(`${GlobalsService.baseUrl}/scholar_offense?token=${token}`, { headers: this.headers2 }).toPromise();
  }

  async getScholarStatus(token) {
    return this.http.get(`${GlobalsService.baseUrl}/scholar_status?token=${token}`, { headers: this.headers2 }).toPromise();
  }

  async getLookUp(token, data) {
    return this.http.post(`${GlobalsService.baseUrlOld}/?token=${token}`, data, { headers: this.headers2 }).toPromise();
  }

  async changePassword(data) {
    return this.http.post(`${GlobalsService.baseUrl2}/change-password`, data).toPromise();
  }

  async getNotifications(scholar_id, token, limit1, limit2) {
    return this.http.post(`${GlobalsService.baseUrl}/notifications/scholar/${scholar_id}/${limit1}/${limit2}?token=${token}`, {}, { headers: this.headers2 }).toPromise();
  }

  async getAllNotifications(scholar_id, token) {
    return this.http.post(`${GlobalsService.baseUrl}/notifications/scholar/${scholar_id}?token=${token}`, {}, { headers: this.headers2 }).toPromise();
  }

  async markAsReadNotification(scholar_id, id) {
    return this.http.post(`${GlobalsService.baseUrl2}/notifications/read/scholar/${scholar_id}/${id}`, {}, { headers: this.headers2 }).toPromise();
  }


  async send_email(data) {
    return this.http.post(`${GlobalsService.email}`, data, { headers: this.headers3 ,'responseType': 'text'}).toPromise();
  }
  
   async verifyOtp(data) {
    return this.http.post(`${GlobalsService.baseUrl2}/verify-otp`,data).toPromise();
   }
   async resendOtp(data) {
    return this.http.post(`${GlobalsService.baseUrl2}/resend-otp`,data).toPromise();
  }
  async msLogin(data) {
    return this.http.post(`${GlobalsService.baseUrl2}/ms-login`,data).toPromise();
  }
   async googleLogin(data) {
    return this.http.post(`${GlobalsService.baseUrl2}/google-login`,data).toPromise();
  }
}
